var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"width":1000,"visible":_vm.visible,"title":'卡密仓库',"maskClosable":false,"footer":false},on:{"cancel":_vm.handleCancel}},[_c('bill')],1)}
var staticRenderFns = []

export { render, staticRenderFns }